import { useCallback, useMemo } from 'react';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import useCompany from 'src/hooks/useCompany';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';
import useRedirect from 'src/hooks/useRedirect';

export default function SearchForDocumentButton() {
  const { company } = useCompany();
  const {
    docNumber,
    poNumber,
    initialReviewDocValidation,
    isReviewPanelLoading,
    ocrPreviewDocument,
    isMergeAttachmentLoading,
    isCreateAndConfirmDocumentLoading,
    closeReviewModal,
  } = useInvoiceScanManager();
  const { getUrl, redirect } = useRedirect();

  const handleRedirect = useCallback(() => {
    closeReviewModal();
    const url = getUrl('enterInvoice')(
      company.companyId,
      encodeURIComponent(docNumber.value),
      encodeURIComponent(poNumber.value),
      true,
      ocrPreviewDocument?.attachId || ''
    );
    redirect(url, false, true);
  }, [
    closeReviewModal,
    getUrl,
    company.companyId,
    docNumber.value,
    poNumber.value,
    ocrPreviewDocument?.attachId,
    redirect,
  ]);

  const { popUpMessage, isSearchForDocDisabled } = useMemo(() => {
    const noDocNumber = !docNumber.value;
    const isCreditMemo = initialReviewDocValidation?.documentType === 'Credit Memo';
    const canUseNegativeQty = initialReviewDocValidation.creditMemoPermissions?.canUseNegativeQty;
    const isButtonDisabled = noDocNumber || (isCreditMemo && !canUseNegativeQty);
    let message = '';
    if (noDocNumber) {
      message = 'Doc # required to Search for Document.';
    } else if (isCreditMemo && !canUseNegativeQty) {
      message = 'Permission to create Credit Memos is required.';
    }
    return {
      popUpMessage: message,
      isSearchForDocDisabled: isButtonDisabled,
    };
  }, [
    docNumber,
    initialReviewDocValidation.creditMemoPermissions?.canUseNegativeQty,
    initialReviewDocValidation?.documentType,
  ]);

  return (
    <PopUp
      content={
        <div className="m-1 max-w-[300px]">
          <PopUpContentWrapper type="Error" contents={[popUpMessage]} />
        </div>
      }
      show={isSearchForDocDisabled}
      anchorAlign={{ horizontal: 'center', vertical: 'top' }}
      popupAlign={{ horizontal: 'center', vertical: 'bottom' }}
    >
      <Button
        color="info"
        disabled={
          isSearchForDocDisabled ||
          isReviewPanelLoading ||
          isMergeAttachmentLoading ||
          isCreateAndConfirmDocumentLoading
        }
        onClick={handleRedirect}
      >
        Search for Document
      </Button>
    </PopUp>
  );
}
